<template>
  <section
    v-if="isFrench"
    class="mx-auto mt-20 max-w-5xl border-t border-black/10 px-4 pt-12 text-[#15120f] sm:px-0"
    :aria-labelledby="`${product}-seo-title`"
  >
    <p class="text-[0.62rem] uppercase tracking-[0.32em] text-black/38">{{ band.eyebrow }}</p>
    <h2
      :id="`${product}-seo-title`"
      class="mt-3 font-['Playfair_Display'] text-[2.25rem] leading-[0.98] tracking-[0] text-black sm:text-[3.1rem]"
    >
      {{ band.title }}
    </h2>
    <p class="mt-5 max-w-3xl text-[0.98rem] leading-[1.8] text-black/68">{{ band.intro }}</p>

    <div class="mt-12 grid gap-10 md:grid-cols-2">
      <article v-for="block in band.blocks" :key="block.title">
        <h3 class="font-['Playfair_Display'] text-[1.5rem] leading-tight text-black">{{ block.title }}</h3>
        <p class="mt-3 text-[0.95rem] leading-[1.75] text-black/66">{{ block.text }}</p>
      </article>
    </div>

    <div class="mt-14" :id="`faq-${product}`">
      <h2 class="font-['Playfair_Display'] text-[1.9rem] leading-tight text-black">{{ band.faqTitle }}</h2>
      <dl class="mt-6 divide-y divide-black/10 border-y border-black/10">
        <div v-for="item in band.faq" :key="item.question" class="py-5">
          <dt class="text-[1rem] font-medium text-black">{{ item.question }}</dt>
          <dd class="mt-2 max-w-3xl text-[0.95rem] leading-[1.75] text-black/66">{{ item.answer }}</dd>
        </div>
      </dl>
    </div>

    <nav class="mt-12 flex flex-wrap gap-x-8 gap-y-3" aria-label="Guides">
      <NuxtLink
        v-for="link in band.guides"
        :key="link.to"
        :to="link.to"
        class="whitespace-nowrap border-b border-black/22 pb-1 text-[0.62rem] uppercase tracking-[0.28em] text-black transition hover:border-black/50"
      >
        {{ link.label }}
      </NuxtLink>
    </nav>
  </section>
</template>

<script setup lang="ts">
import { productSeoContent, type ProductSeoType } from '~/utils/productSeoContent'

const props = defineProps<{ product: ProductSeoType }>()
const siteLocale = useSiteLocale()
const isFrench = computed(() => siteLocale.value === 'fr')
const band = computed(() => productSeoContent[props.product].band)

useHead(() => isFrench.value
  ? {
      script: [
        {
          key: `${props.product}-faq-jsonld`,
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: band.value.faq.map(item => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: { '@type': 'Answer', text: item.answer }
            }))
          })
        }
      ]
    }
  : {})
</script>
